(() => {
  if (customElements.get('rosanera-card-colors')) return;
  class RosaneraCardColors extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', event => {
        const swatch = event.target.closest('.rosanera-card-colors__swatch');
        if (!swatch || !this.contains(swatch)) return;
        event.preventDefault();
        event.stopPropagation();
        this.select(swatch);
      });
      this.addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End',' '].includes(event.key)) return;
        const swatches = Array.from(this.querySelectorAll('[role="radio"]'));
        const index = swatches.indexOf(event.target.closest('[role="radio"]'));
        if (index < 0) return;
        event.preventDefault();
        let next = index;
        if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = swatches.length - 1;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + swatches.length) % swatches.length;
        else if (event.key !== ' ') next = (index + 1) % swatches.length;
        swatches[next].focus();
        this.select(swatches[next]);
      });
    }
    select(swatch) {
      const card = this.closest('.card-wrapper');
      const image = card && card.querySelector('.card__media .media > img');
      if (!card || !image || !swatch.dataset.image) return;
      this.querySelectorAll('[role="radio"]').forEach(item => {
        const selected = item === swatch;
        item.setAttribute('aria-checked', String(selected));
        item.tabIndex = selected ? 0 : -1;
      });
      image.srcset = swatch.dataset.srcset;
      image.src = swatch.dataset.image;
      image.alt = swatch.dataset.imageAlt;
      card.classList.add('rosanera-color-selected');
      card.querySelectorAll('a[href]').forEach(link => {
        if (link.closest('rosanera-card-colors')) return;
        const url = new URL(link.href, location.origin);
        const selectedUrl = new URL(swatch.href, location.origin);
        if (url.pathname === selectedUrl.pathname) link.href = swatch.href;
      });
      card.querySelectorAll('[data-product-url]').forEach(button => {
        button.dataset.productUrl = swatch.href;
      });
      this.querySelector('.rosanera-card-colors__label').textContent =
        swatch.dataset.color + (swatch.classList.contains('is-unavailable') ? ' — esaurito' : '');
      const price = card.querySelector('.price');
      if (price) {
        const sale = swatch.dataset.onSale === 'true';
        price.classList.toggle('price--on-sale', sale);
        const regularPrice = price.querySelector('.price__regular .price-item--regular');
        const salePrice = price.querySelector('.price__sale .price-item--sale');
        const comparePrice = price.querySelector('.price__sale .price-item--regular');
        if (regularPrice) regularPrice.textContent = swatch.dataset.price;
        if (salePrice) salePrice.textContent = swatch.dataset.price;
        if (comparePrice) comparePrice.textContent = sale ? swatch.dataset.comparePrice : '';
      }
    }
  }
  customElements.define('rosanera-card-colors', RosaneraCardColors);
})();